import { abTestTest } from '@frontend/web/experiments/tests/ab-test-test';
export const tests = [abTestTest];
